import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { API_BASE_URL as BASE } from '@/api/apiConfig';

const API = `${BASE}/api`;

interface ContextProfileNudgeModalProps {
  onClose: () => void;
}

const getAuthHeaders = (): Record<string, string> => {
  const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const ContextProfileNudgeModal: React.FC<ContextProfileNudgeModalProps> = ({ onClose }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleLater = async () => {
    // "나중에 하기" → use_yn='N' 으로 빈 레코드 생성
    setLoading(true);
    try {
      await fetch(`${API}/user/alt-profiles`, {
        method: 'POST',
        headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
          useYn: 'N',
          contextCodes: {},
          requiredKeywords: '',
          forbiddenKeywords: '',
          customInstruction: '',
          engYn: 'N',
        }),
      });
    } catch {
      // 실패해도 모달은 닫음
    } finally {
      setLoading(false);
      onClose();
    }
  };

  const handleGoRegister = () => {
    onClose();
    navigate('/dashboard/profile/context');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full mx-4 p-6 space-y-4">
        {/* 아이콘 */}
        <div className="flex justify-center">
          <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center text-3xl">
            🎯
          </div>
        </div>

        {/* 제목 */}
        <div className="text-center space-y-1">
          <h2 className="text-lg font-bold text-gray-900">더 정확한 ALT를 위해</h2>
          <h3 className="text-lg font-bold text-blue-600">컨텍스트 프로필을 등록해보세요!</h3>
        </div>

        {/* 설명 */}
        <p className="text-sm text-gray-600 text-center leading-relaxed">
          업종, 사이트 유형, 서비스 대상 등을 설정하면<br />
          AI가 더 맞춤화된 ALT 텍스트를 생성합니다.
        </p>

        {/* 혜택 목록 */}
        <ul className="space-y-1.5 text-sm text-gray-700 bg-blue-50 rounded-lg p-4">
          <li className="flex items-start gap-2">
            <span className="text-blue-500 mt-0.5">✓</span>
            <span>업종에 맞는 전문 용어 자동 적용</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-blue-500 mt-0.5">✓</span>
            <span>원하는 길이·문체로 ALT 생성</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-blue-500 mt-0.5">✓</span>
            <span>필수 포함어·금지어 설정 가능</span>
          </li>
        </ul>

        {/* 버튼 */}
        <div className="flex gap-3 pt-1">
          <Button
            variant="outline"
            className="flex-1"
            onClick={handleLater}
            disabled={loading}
          >
            나중에 하기
          </Button>
          <Button
            className="flex-1"
            onClick={handleGoRegister}
            disabled={loading}
          >
            등록하기
          </Button>
        </div>
      </div>
    </div>
  );
};
